
import PageState from "./state";
import mutations from "./mutations";
import { getModule } from '@/store/store';
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device= isAndroid?"H5_ANDROID":"H5_IOS"
let API1 = {
	//ajax地址
	// 登录用户会员状态
	getVipInfo: `get /apis/moyin-account/v1/vip/status`,
	// 专辑列表
	getMyCompanyList: `get /apis/tts-web-api/v1/company`,
	// 专辑状态
	// 获取购买状态
	getPaymentStatus: `get /apis/tts-web-api/v1/buy/audio/couldPay`,
	// 检查token状态
	checkTokenStatus: `get https://passport.mobvoi.com/user/info/token`,
	// 兼容wechat-token
	checkWechatTokenStatus: `get /apis/moyin-account/v1/weChat/validateToken`,
	// 获取文字的发音

  // 查询会员渠道名称
  getChannelName: {
		custom: true,
    url: `/apis/moyin-account/v1/vip/getWxJsApiChannelName?`,
		method: 'get'
  },
  // 查询发音人列表
  getSpeakerListApi: {
		custom: true,
		url: `/apis/tts-web-api/v1/channel/getChannelPresent?`,
		method: 'get'
  },
  // 新版查询发音人列表
  getSpeakerListApiNew: {
	  custom: true,
	  url: `/apis/moyin-account/v1/channel/getChannelSpeakerSelect?`,
	  method: 'get'
  },
  // 查询会员开通价格列表
  getVipPriceList: {
		custom: true,
		url: `/apis/moyin-account/v1/vip/price2?`,
		method: 'get'
  },
	getUpgradableStatus: {
		custom: true,
		url: `/apis/moyin-account/v1/speakerVip/getUpgradableStatus`,
		method: 'get'
  },
  // 支付费用
	paySuperVip: {
		custom: true,
		url: (data: any) => `/apis/moyin-account/v1/vip/wxJsApiOrder?phone=${data.phone
			}&packageId=${data.packageId
			}&channelCode=${data.channelCode
			}&speakerStoreIDArray=${data.speakerStoreIDArray
			}&speakerIdArray=${data.speakerIdArray
			}&payType=${data.payType
			}&sourceType=${data.sourceType
			}&jsCode=${
                data.jsCode
            }&device=${device
			}`,
		method: 'post'
	},
	// 支付费用
	h5UpgradeOrder: {
		custom: true,
		url: (data: any) => `/apis/moyin-account/v1/speakerVip/h5UpgradeOrder?phone=${
			data.phone
		}&packageId=${
			data.packageId
		}&channelCode=${
			data.channelCode
		}&speakerStoreIDArray=${
			data.speakerStoreIDArray
		}&jsCode=${
			data.jsCode
		}&device=${
			device
		}&payType=${
			data.payType
		}&isUpgrade=true`,
		method: 'post'
	},
	
	showPaymentInfo: `get /apis/moyin-account/v1/speakerVip/showPaymentInfo`,
	getVipCenter:`get /apis/tts-web-api/vipCenter/priorityComparison`,

	/****************************** 元创岛接口 ******************************/

	// 获取会员套餐列表
	getYcdPackageListApi: {
		custom: true,
		url: `/baohuo-apis/baohuo-account/package/getPackageByType`,
		method: 'get'
	},
	
	// 获取元创岛会员权益列表
	getYcdVipRightsListApi: {
		custom: true,
		url: `/baohuo-apis/baohuo-account/v1/memberCenter/queryMemberRightList`,
		method: 'get'
	},
	
	// 根据手机号获取手机号的会员信息
	getPhoneVipType: {
		custom: true,
		url: `/baohuo-apis/baohuo-account/v1/memberCenter/getVipType`,
		method: 'get'
	},
	
	// 元创岛购买套餐订单
	createYcdOrderApi: {
		custom: true,
		url: `/baohuo-apis/baohuo-account/order/create`,
		method: 'post'
	},

	// 查询购买订单状态
	getYcdPayStatusInfo: `get /baohuo-apis/baohuo-account/order/detail`,
	//查询字数包套餐
	getWordPack: `get /apis/moyin-account/customizeRights/package`,
	//h5字数包订单生成
	createWordH5Order: {
		custom: true,
		url: (data: any) =>`/apis/moyin-account/customizeRights/h5Order?promottype=FENXIAO_${data.channelCode}&bd_vid=${data.channelCode}&promotsource=${data.channelCode}`,
		method: 'post'
	},
	
};



let API2 = {
	...API1
	//网关
	// getAllBusDomainList: `post api/EmpPlatform/SMC180320000001/getUserCompanyList`,
};
let APIS = process.env.NODE_ENV == 'development' ? API1 : API2;

export default {
	...getModule({
		state: new PageState(),
		mutations,
		actions: {},
		APIS,
		name: "VipWechatPayPage"
	})
};
